/**
 * Exhaustiveness guard. Use as the `default:` of a switch over a union so
 * that adding a union member becomes a compile error at the switch.
 * Throws at runtime if an out-of-union value slips through (e.g. DB drift).
 */
export function assertNever(value: never, message?: string): never {
  let rendered: string
  try {
    rendered = JSON.stringify(value) ?? String(value)
  } catch {
    rendered = String(value)
  }
  throw new Error(`${message ?? 'Unexpected value'}: ${rendered}`)
}
